import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { CustomTableProps } from "utils/interface";
import { TablePagination } from "@mui/material";
import CustomTableHeader from "./header/CustomTableHeader";

const CustomTable: React.FC<CustomTableProps> = ({
  loading,
  columns,
  rows,
  handleChangeRowsPerPage,
  handleChangePage,
  pagination,
}) => {
  return (
    <>
      <TableContainer
        component={Paper}
        sx={{
          maxHeight: pagination ? "calc(100% - 131px)" : "calc(100% - 78px)",
          width: "100%",
          maxWidth: "100%",
          minWidth: 0,
          overflowX: "auto",
          boxSizing: "border-box",
        }}
      >
        <Table stickyHeader>
          <CustomTableHeader columns={columns} />
          {!loading && rows.length === 0 ? (
            <TableBody>
              <TableRow key={-1}>
                <TableCell colSpan={columns.length} align="center">
                  No data available
                </TableCell>
              </TableRow>
            </TableBody>
          ) : (
            <TableBody>
              {rows.map((row: any, index: number) => (
                <TableRow key={index} hover tabIndex={-1}>
                  {columns.map((column: any) => {
                    const value = row[column.id];
                    return (
                      <TableCell
                        key={column.id}
                        align={column.align || "left"}
                        sx={{
                          maxWidth: column.maxWidth,
                          minWidth: column.minWidth,
                        }}
                      >
                        {column.render !== undefined
                          ? column.render(row, value)
                          : value}
                      </TableCell>
                    );
                  })}
                </TableRow>
              ))}
            </TableBody>
          )}
        </Table>
      </TableContainer>
      {pagination && (
        <TablePagination
          rowsPerPageOptions={[25, 50, 100, 200]}
          component="div"
          count={pagination.total}
          rowsPerPage={pagination.per_page}
          page={pagination.page}
          onPageChange={(event, newPage) => handleChangePage?.(event, newPage)} // Adjusted here
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      )}
    </>
  );
};

export default CustomTable;
